import { SET_LOADED } from './actions';


const initialState = {
	loaded: false
}

export const birdLoaderReducer = (state = initialState, action) => {
  switch (action.type) { 
    case SET_LOADED: 
      return {
        loaded: true
      };                                
    default:
      return state;
  }
};